import Vue from 'vue';
import Vuex from 'vuex';
import _camelCase from 'lodash/camelCase';

Vue.use(Vuex);

/**
 * Dyanmically loads all stores that are placed in this directory.
 *
 * Note: this assumes that all stores are in a folder with an index.js
 * file that uses "export default" to export state, mutations, actions,
 * and getters.
 */
const requireModule = require.context('.', true, /index\.js/);
const modules = requireModule.keys().reduce((moduleCollection, filename) => {
  // Exclude this file
  if (filename !== './index.js') {
    // Convert: ./module-name/index.js to moduleName
    moduleCollection[_camelCase(filename.replace(/index\.js$/, ''))] = requireModule(filename).default;
  }
  return moduleCollection;
}, {});

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

const Store = new Vuex.Store({
  modules,
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.APP_ENV === 'dev',
});

export default function defaultExport(/* { ssrContext } */) {
  return Store;
}

export { Store };
